/* src/app/admin-dashboard/portal-access/portal-access.component.css */
.pa-wrap {
  padding: 16px;
}
.pa-toolbar {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 12px;
}
.pa-spacer {
  flex: 1 1 auto;
}
.pa-note {
  margin: 0;
  color: #555;
  font-size: 13px;
  max-width: 720px;
}
.pa-warn {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #8a6417;
  margin-top: 8px;
}
.pa-warn mat-icon {
  font-size: 18px;
  height: 18px;
  width: 18px;
}
.pa-muted {
  color: #888;
  font-size: 12px;
}
.pa-chip {
  border-radius: 12px;
  padding: 4px 10px;
  font-size: 12px;
  font-weight: 600;
  background: #eef1f4;
  color: #555;
  white-space: nowrap;
}
.pa-chip-warn {
  background: #fdecea;
  color: #c0392b;
}
.pa-chip-ok {
  background: #e8f5e9;
  color: #2e7d32;
}
.pa-chip-off {
  background: #f0f0f0;
  color: #888;
}
.pa-search {
  width: 340px;
  max-width: 100%;
}
.pa-search .mat-mdc-form-field-icon-prefix {
  padding-right: 6px;
  color: #888;
}
.pa-card {
  border: 1px solid #e3e6ea;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 20px;
  background: #fbfcfd;
}
.pa-card-title {
  margin: 0 0 12px;
  font-size: 15px;
  font-weight: 600;
}
.pa-form-row {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}
.pa-field {
  flex: 1 1 260px;
  min-width: 240px;
}
.pa-form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 8px;
}
.pa-picker {
  border: 1px solid #e3e6ea;
  border-radius: 6px;
  background: #fff;
  margin-top: 4px;
}
.pa-picker-head {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px 0;
  flex-wrap: wrap;
}
.pa-picker-list {
  max-height: 260px;
  overflow-y: auto;
  padding: 4px 0;
}
.pa-picker-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 6px 12px;
  cursor: pointer;
  font-size: 13px;
}
.pa-picker-item:hover {
  background: #f5f7f9;
}
.pa-picked {
  background: #eef5ff;
}
.pa-picker-name {
  font-weight: 500;
}
.pa-table-wrap {
  overflow-x: auto;
}
.pa-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}
.pa-table th,
.pa-table td {
  text-align: left;
  padding: 8px 10px;
  border-bottom: 1px solid #eee;
  vertical-align: middle;
}
.pa-table th {
  color: #666;
  font-weight: 600;
}
.pa-cust-cell {
  max-width: 320px;
}
.pa-row-off td {
  background: #fafafa;
  color: #999;
}
.pa-role-select {
  min-width: 120px;
  font-size: 13px;
}
.pa-actions {
  white-space: nowrap;
  text-align: right;
}
.pa-empty {
  padding: 24px;
  text-align: center;
  color: #888;
}
.pa-error {
  color: #c0392b;
}
.pa-cust-chip {
  display: inline-block;
  margin: 2px 4px 2px 0;
  padding: 2px 8px;
  border-radius: 10px;
  background: #eef1f4;
  color: #333;
  font-size: 12px;
}
/*# sourceMappingURL=portal-access.component.css.map */
